// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_33-1";
export var rateTableServiceLevelDropdown = "_33-3";
export var rateTableTypeDropdown = "_33-0";
export var rateTableValueModeDropdown = "_33-2";